import axios from '@/libs/axios'

class CarrerasService {
  /**
   * Obtener todas las carreras
   * @returns {Promise<Array>} - Lista de carreras
   */
  async getAll() {
    try {
      const response = await axios.get('/carreras')
      return response.data
    } catch (error) {
      console.error('Error al obtener carreras:', error)
      throw error
    }
  }

  /**
   * Obtener una carrera por ID
   * @param {number} id - ID de la carrera
   * @returns {Promise<Object>} - Datos de la carrera
   */
  async getById(id) {
    try {
      const response = await axios.get(`/carreras/${id}`)
      return response.data
    } catch (error) {
      console.error('Error al obtener carrera:', error)
      throw error
    }
  }

  /**
   * Crear una nueva carrera
   * @param {Object} carreraData - Datos de la carrera
   * @returns {Promise<Object>} - Carrera creada
   */
  async create(carreraData) {
    try {
      const response = await axios.post('/carreras', carreraData)
      return response.data
    } catch (error) {
      console.error('Error al crear carrera:', error)
      throw error
    }
  }

  /**
   * Actualizar una carrera
   * @param {number} id - ID de la carrera
   * @param {Object} carreraData - Datos actualizados
   * @returns {Promise<Object>} - Carrera actualizada
   */
  async update(id, carreraData) {
    try {
      const response = await axios.put(`/carreras/${id}`, carreraData)
      return response.data
    } catch (error) {
      console.error('Error al actualizar carrera:', error)
      throw error
    }
  }

  /**
   * Eliminar una carrera (soft delete)
   * @param {number} id - ID de la carrera
   * @returns {Promise<void>}
   */
  async delete(id) {
    try {
      await axios.delete(`/carreras/${id}`)
    } catch (error) {
      console.error('Error al eliminar carrera:', error)
      throw error
    }
  }
}

export default new CarrerasService()

